/* Keyboard activation for North's custom filter control. */
document.addEventListener('keydown', (event) => {
  if (event.target.matches('facets-toggle[role="button"]') && ['Enter', ' '].includes(event.key)) {
    event.preventDefault();
    event.target.click();
  }
});

// Keep native sort/price/availability choices when using Shopify's French tag fallback.
document.addEventListener('click', event => {
  const link=event.target.closest('.rl-tag-filter a, .rl-active-tags a');
  if(!link)return;
  const url=new URL(link.href,location.origin), params=new URLSearchParams(location.search);
  params.delete('page'); params.delete('section_id'); params.delete('view');
  url.search=params.toString(); link.href=url.href;
});

document.addEventListener('click',event=>{
 const chip=event.target.closest('a[data-filter-aliases]');if(!chip)return;
 const url=new URL(location.href),key=chip.dataset.filterParam,remove=chip.dataset.filterAliases.split('||');
 const retained=url.searchParams.getAll(key).filter(value=>!remove.includes(value));
 url.searchParams.delete(key);retained.forEach(value=>url.searchParams.append(key,value));url.searchParams.delete('page');chip.href=url.toString();
});
